import styled from 'styled-components';

export const StyledHeaderWrapper = styled.header`
  background-color: ${({ theme }) => theme.color.white};
  padding: ${({ theme }) => theme.space[4]}px;
  display: flex;
  align-items: center;
  position: sticky;
  top: ${({ theme }) => theme.space[0]}px;
  z-index: 1;
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
`;

export const StyledTitleWrapper = styled.h1`
  flex: 1;
  text-align: center;
  margin-inline-end: ${({ theme }) => theme.space[6]}px;
  margin-inline-start: ${props => (props.additionalElement ? '90' : '0')}px;
`;
